// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"PageTitle_PageTitle__2G2ir","title":"PageTitle_title__110W0","counter":"PageTitle_counter__1wuvM","subtitle":"PageTitle_subtitle__25gpM"};